import "./styles.css";

import { LivestreamingApp } from "./app";
import { LivestreamingApiClient } from "./lib/api";
import { BandLabAuthStore } from "./lib/auth";

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;
const accountsBaseUrl = import.meta.env.VITE_BANDLAB_ACCOUNTS_BASE_URL as string | undefined;
const redirectUri = import.meta.env.VITE_BANDLAB_REDIRECT_URI as string | undefined;
const identityAudience = import.meta.env.VITE_BANDLAB_IDENTITY_AUDIENCE as string | undefined;

if (!apiBaseUrl) {
    throw new Error("VITE_API_BASE_URL is required");
}

if (!accountsBaseUrl) {
    throw new Error("VITE_BANDLAB_ACCOUNTS_BASE_URL is required");
}

const rootElement = document.querySelector<HTMLElement>("#app");
if (!rootElement) {
    throw new Error("Missing #app root element");
}

const authStore = new BandLabAuthStore(accountsBaseUrl, redirectUri, identityAudience);

const app = new LivestreamingApp({
    apiClient: new LivestreamingApiClient(apiBaseUrl, authStore),
    authStore,
    root: rootElement,
});

void app.initialize();
